var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatalogIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83789 8.77026H10.3195",
    stroke: "url(#paint0_linear_469_11903)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83789 10.7588H10.3195",
    stroke: "url(#paint1_linear_469_11903)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83789 12.7485H10.3195",
    stroke: "url(#paint2_linear_469_11903)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83789 14.7368H10.3195",
    stroke: "url(#paint3_linear_469_11903)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3995 18.0761H0.755859V5.43237H7.82483H13.3995V18.0761Z",
    stroke: "url(#paint4_linear_469_11903)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64648 5.43113V1.6748H13.7143H19.2902V14.3185H13.4017",
    stroke: "url(#paint5_linear_469_11903)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85352 1.75635L13.3535 5.44945",
    stroke: "url(#paint6_linear_469_11903)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_469_11903",
    x1: 7.0787,
    y1: 8.77026,
    x2: 7.0787,
    y2: 9.77026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_469_11903",
    x1: 7.0787,
    y1: 10.7588,
    x2: 7.0787,
    y2: 11.7588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_469_11903",
    x1: 7.0787,
    y1: 12.7485,
    x2: 7.0787,
    y2: 13.7485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_469_11903",
    x1: 7.0787,
    y1: 14.7368,
    x2: 7.0787,
    y2: 15.7368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_469_11903",
    x1: 7.0777,
    y1: 5.43237,
    x2: 7.0777,
    y2: 18.0761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_469_11903",
    x1: 12.9683,
    y1: 1.6748,
    x2: 12.9683,
    y2: 14.3185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_469_11903",
    x1: 10.1035,
    y1: 1.75635,
    x2: 10.1035,
    y2: 5.44945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB077"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogIcon);
export default __webpack_public_path__ + "static/media/CatalogIcon.bff2d6d4331bc75e5305097ec749911d.svg";
export { ForwardRef as ReactComponent };